import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, MessageCircle } from "lucide-react";
import { BRAND, NAV } from "../data/site";

const PAGES = [
  { label: "Oferta", to: "/oferta" },
  { label: "Szkolenia", to: "/szkolenia" },
  { label: "Dla agencji", to: "/dla-agencji" },
  { label: "Kontakt", to: "/kontakt" },
];

export const Footer = () => {
  return (
    <footer className="relative bg-graphite pt-16 pb-8 border-t border-white/10" data-testid="site-footer">
      <div className="container-pm">
        <div className="grid md:grid-cols-[1.4fr_1fr_1.1fr] gap-10 pb-12">
          <div>
            <img src={BRAND.logo} alt="PMPOINT" className="h-8 w-auto mb-5" width="160" height="32" />
            <p className="text-sm text-white/55 max-w-[38ch] mb-5">
              Marketing i technologia dla ambitnych twórczyń 18+. Zamieniamy uwagę w realne przychody —
              legalnie, dyskretnie i transparentnie.
            </p>
            <a
              href={BRAND.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-lg bg-[#25D366] text-white text-sm font-bold hover:bg-[#1EBE5D] transition-colors"
            >
              <MessageCircle size={16} /> Napisz na WhatsApp
            </a>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Nawigacja</h4>
            <ul className="space-y-2.5">
              {PAGES.map((p) => (
                <li key={p.to}>
                  <Link to={p.to} className="text-sm text-white/55 hover:text-coral transition-colors">
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-white/55">
                <Phone size={15} className="text-coral" />
                <a href={`tel:+${BRAND.phoneIntl}`} className="hover:text-coral transition-colors" data-testid="footer-phone">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm text-white/55">
                <Mail size={15} className="text-coral" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-coral transition-colors" data-testid="footer-email">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/55">
                <MapPin size={15} className="text-coral mt-0.5" />
                <span>{BRAND.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-white/40 leading-relaxed">
            © {new Date().getFullYear()} {BRAND.legalName} · NIP {BRAND.nip} · {BRAND.address}
            <br />
            Współpraca wyłącznie z osobami pełnoletnimi (18+).
          </p>
          <div className="flex gap-6 text-xs text-white/40">
            <Link to="/polityka-prywatnosci" className="hover:text-white/70 transition-colors">Polityka prywatności</Link>
            <Link to="/regulamin" className="hover:text-white/70 transition-colors">Regulamin</Link>
          </div>
        </div>

        <div className="pt-6 text-center">
          <a
            href="https://apisdesign.pl"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-credit"
            className="text-xs text-white/30 hover:text-coral transition-colors"
          >
            design &amp; development by apisdesign.pl
          </a>
        </div>
      </div>
    </footer>
  );
};
